import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import PropertyCard from "@/components/PropertyCard";
import { getRecent, removeRecent, clearRecent } from "@/lib/recentlyViewed";
import { X, History } from "lucide-react";

export const RecentlyViewed = ({ limit = 8 }) => {
  const { t } = useLang();
  const [ids, setIds] = useState(getRecent);
  const [props, setProps] = useState([]);

  useEffect(() => {
    if (!ids.length) { setProps([]); return; }
    api.get("/properties", { params: { ids: ids.join(",") } })
      .then((r) => {
        const byId = Object.fromEntries(r.data.map((p) => [p.id, p]));
        setProps(ids.map((id) => byId[id]).filter(Boolean).slice(0, limit));
      })
      .catch(() => setProps([]));
  }, [ids, limit]);

  if (!props.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 home-section" data-testid="recently-viewed-section">
      <div className="flex items-end justify-between home-section-head">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-brand flex items-center gap-2"><History className="w-4 h-4" />{t.recent.subtitle}</div>
          <h3 className="font-serif text-4xl md:text-5xl text-stone-900 mt-3">{t.recent.title}</h3>
        </div>
        <button onClick={() => setIds(clearRecent())} className="text-sm text-stone-500 hover:text-brand underline underline-offset-4" data-testid="recent-clear-all">
          {t.recent.clear}
        </button>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {props.map((p) => (
          <div key={p.id} className="relative group" data-testid={`recent-item-${p.id}`}>
            <PropertyCard property={p} size="small" />
            <button
              onClick={() => setIds(removeRecent(p.id))}
              title={t.recent.remove}
              className="absolute top-3 right-14 z-10 w-8 h-8 rounded-full bg-white/90 text-stone-700 shadow flex items-center justify-center hover:bg-white hover:text-red-600 transition-colors"
              data-testid={`recent-remove-${p.id}`}
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};
